import { AbstractCoroutine2jzyhqo91sb0o as AbstractCoroutine } from '../AbstractCoroutine.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { JobCancellationException2g3wpni5v5fkt as JobCancellationException } from '../Exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  close$default2suggcywjwe8g as close$default,
  SendChannel38sllbxw662ws as SendChannel,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
} from './Channel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelCoroutineClass;
function ChannelCoroutine() {
  if (ChannelCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(parentContext, _channel, initParentJob, active) {
        super(parentContext, initParentJob, active);
        this._channel_1 = _channel;
      }
      cancel_hkmm2i_k$(cause) {
        if (this.get_isCancelled_trk8pu_k$())
          return Unit_instance;
        var tmp;
        if (cause == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().new_kotlinx_coroutines_JobCancellationException_o17dg7_k$(null == null ? this.cancellationExceptionMessage_a64063_k$() : null, null, this);
        } else {
          tmp = cause;
        }
        this.cancelInternal_fraw7c_k$(tmp);
      }
      cancel$default_880p35_k$(cause, $super) {
        return this.cancel$default_8haxne_k$(cause, ($super == null ? true : $super instanceof ChannelCoroutine()) ? $super : THROW_CCE());
      }
      cancelInternal_fraw7c_k$(cause) {
        var exception = this.toCancellationException$default_r7tnxv_k$(cause);
        this._channel_1.cancel_hkmm2i_k$(exception);
        this.cancelCoroutine_rpko3c_k$(exception);
      }
      get_isClosedForSend_ajczci_k$() {
        return this._channel_1.get_isClosedForSend_ajczci_k$();
      }
      *send_44jogj_k$(element, $completion) {
        yield* this._channel_1.send_44jogj_k$(element, $completion);
        return Unit_instance;
      }
      trySend_62dpg8_k$(element) {
        return this._channel_1.trySend_62dpg8_k$(element);
      }
      close_ukldxa_k$(cause) {
        return this._channel_1.close_ukldxa_k$(cause);
      }
      invokeOnClose_xlde4o_k$(handler) {
        this._channel_1.invokeOnClose_xlde4o_k$(handler);
      }
      *receive_awoumx_k$($completion) {
        return yield* this._channel_1.receive_awoumx_k$($completion);
      }
      iterator_jk1svi_k$() {
        return this._channel_1.iterator_jk1svi_k$();
      }
    }
    protoOf($).close$default_kcbl7u_k$ = close$default;
    initMetadataForClass($, 'ChannelCoroutine', VOID, VOID, [SendChannel(), ReceiveChannel()], [1, 0]);
    ChannelCoroutineClass = $;
  }
  return ChannelCoroutineClass;
}
//region block: exports
export {
  ChannelCoroutine as ChannelCoroutine12l2gxei4u780,
};
//endregion

//# sourceMappingURL=ChannelCoroutine.mjs.map
